import { render, staticRenderFns } from "./COD-Branch-Split.vue?vue&type=template&id=3fa32b10&scoped=true"
import script from "./COD-Branch-Split.vue?vue&type=script&lang=js"
export * from "./COD-Branch-Split.vue?vue&type=script&lang=js"
import style0 from "./COD-Branch-Split.vue?vue&type=style&index=0&id=3fa32b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa32b10",
  null
  
)

export default component.exports